import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CollectiveDataProvider, CollectiveLoadState } from '../_providers/collective-data-provider';

@Injectable({
  providedIn: 'root'
})
export class PublicRedirectionGuard implements CanActivate  {
  public collectiveConfig = null;

  constructor (
    private router: Router,
    private collectiveDataProvider: CollectiveDataProvider
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest(
      this.collectiveDataProvider.getData(),
      this.collectiveDataProvider.getLoadState()
    ).pipe(
      filter((result: [any, CollectiveLoadState]) => result[1] !== 'loading'),
      take(1),
      map((result: [any, CollectiveLoadState]) => {
        this.collectiveConfig = result[0];
        const loadState = result[1];

        if (loadState === 'error' || environment.protected || this.collectiveConfig.active === 0) {
          return true;
        }

        if (this.collectiveConfig.active === 1) {
          return this.router.parseUrl(`/${next.params.locale}/service-index`);
        }

        return true;
      })
    );
  }
}
